module.exports = __webpack_public_path__ + "static/img/hotline.d9e0824.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/hotline.png
// module id = cf9G
// module chunks = 1